<template>
	<div class="owl-carousel"
		 @mouseover='stopSlider'
		 @touchstart='stopSlider'
		 @touchend="startSlider"
		 @mouseout="startSlider">
		<div class="item" v-for="item in items">
			<a v-if="item.img" :href="item.href" class="banner" :lazy-background="item.img">
      </a>
		</div>
	</div>
</template>

<script>
	module.exports = {
		props: ['items'],
		data () {
			return {
				interval: '',
				step: 0
			}
		},
		updated() {
			this.$emit('updated', {
				owlSettings: {
					items: 1,
					// loop: this.items.length > 1 ? true : false,
					loop: true,
					nav: false,
					responsive: {
						0: {
							items: 2,
						},
						400: {
							items: 2,
						},
						640: {
							items: 3,
						},
						800: {
							items: 5,
						},
						1180: {
							items: 7,
						}
					},
					onInitialized: (e) => {
					let v = $(e.target).find('.owl-stage').width();
					let wBlock = $('.slider-swimSlider').width();

						//чекаем текущий скрол
						let para = $(e.target).find('.owl-stage')[0];
						let compStyles = window.getComputedStyle(para);
						this.step = +compStyles.getPropertyValue('transform').slice(19).split(',')[0];
						// console.log(compStyles.getPropertyValue('transform').slice(19).split(',')[0]);

						this.interval = setInterval(() => {
						// console.log(this.step);
						// console.log(this.step, -v +  wBlock);
							if(this.step <= -v + wBlock){
								this.step = 0;
								// $(e.target).find('.owl-stage').css('transition', 'unsetunset');
								$(e.target).find('.owl-stage').css({'transform': 'translateX('+ this.step +'px)', 'transition' : 'unset'});
								this.step--;
								// clearInterval(this.interval);
							} else {
								$(e.target).find('.owl-stage').css({'transform': 'translateX('+ this.step +'px)'});
								// $(e.target).find('.owl-stage').css
								this.step--;
							}
						}, 50);
					}
				}
			});
		},
	 	methods: {

		stopSlider(e){
		  clearInterval(this.interval);
		},
		startSlider(e) {
			let v = $(e.target).closest('.owl-stage').width();
			let wBlock = $('.slider-swimSlider').width();

			//чекаем текущий скрол
			let para = $('.slider-swimSlider').find('.owl-stage')[0];
			let compStyles = window.getComputedStyle(para);
			this.step = +compStyles.getPropertyValue('transform').slice(19).split(',')[0];
			// console.log(compStyles.getPropertyValue('transform').slice(19).split(',')[0]);

		  this.interval = setInterval(() => {
			  // $(e.target).closest('.owl-stage').trigger('scroll');
			  if(this.step <= -v + wBlock){
				  this.step = 0;
				  // $(e.target).find('.owl-stage').css('transition', 'unsetunset');
				  $(e.target).closest('.owl-carousel').find('.owl-stage').css({'transform': 'translateX('+ this.step +'px)', 'transition' : 'unset'});
				  this.step--;
				  // clearInterval(this.interval);
			  } else {
				  $(e.target).closest('.owl-carousel').find('.owl-stage').css({'transform': 'translateX('+ this.step +'px)'});
				  this.step--;
			}
		  }, 50);
		}
	  },
		mounted() {
			setTimeout(() => {
				lazyBackground();
			}, 4)
			
		}
	}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
  width: 100%;
	.slider-swimSlider {
    @include single-transition();
    .owl-stage{
      @include single-transition();
    }
		.owl-carousel {
			.item {
        width: 100%;
        height: 100px;
        .banner{
          display: block;
          width: 100%;
          height: 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
			}
		}
	}
	.owl-stage {
		transition-timing-function: cubic-bezier(.39,.41,.72,.71) !important;
	}

}
</style>



// WEBPACK FOOTER //
// swimSlider.vue?ed58ff0a